function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("regenerator-runtime/runtime.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.date.to-iso-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('./util'),
    guid = _require.guid,
    getConsumerId = _require.getConsumerId,
    getOsVersion = _require.getOsVersion,
    getAppClient = _require.getAppClient,
    getAppIdForH5 = _require.getAppIdForH5,
    getQueryString = _require.getQueryString,
    setlocalStorage = _require.setlocalStorage,
    getlocalStorage = _require.getlocalStorage,
    deepClone = _require.deepClone,
    appUa = _require.appUa,
    sleep = _require.sleep,
    getWebLoadTimeInfo = _require.getWebLoadTimeInfo,
    saveLocalStorage = _require.saveLocalStorage,
    getNetworkInfo = _require.getNetworkInfo,
    getNetworkMsg = _require.getNetworkMsg,
    getWechatVerison = _require.getWechatVerison,
    monitorLog = _require.monitorLog,
    format = _require.format,
    getLogType = _require.getLogType;

var codeMap = require('./util/codeMap').default;
/**
 * 错误上报函数
 */


var YjErrorReport = /*#__PURE__*/function () {
  "use strict";

  /**
   * @param {*} vue 
   * @param {*} opt 
   */
  function YjErrorReport(vue, opt) {
    _classCallCheck(this, YjErrorReport);

    if (!opt) throw new Error('错误监控埋点-----> 请传入初始化参数~');
    if (!opt.projectName) throw new Error('错误监控埋点-----> 请传入项目名projectName');
    if (typeof window === 'undefined') return;
    this.errorReportUser = guid();
    this.consumerId = getConsumerId();
    this.environment = opt.environment || 'release';
    this.projectName = opt.projectName;
    this.packageName = opt.packageName || '';
    this.packageVersion = opt.packageVersion || '';
    this.ajaxCodefilter = opt.ajaxCodefilter || [];
    this.ajaxCodefilter.push(304);
    this.stageFlowPage = opt.stageFlowPage || [];
    this.apiReportSwitch = Math.ceil(Math.random() * 10) <= (opt.apiReportAmount || 10); //  接口数据上报默认上报100%

    this.currentStage = ''; // 当前上报阶段流

    this.currentStageTime = {};
    this.stageObj = {}; // 当前阶段流对象

    this.webviewTime = 0;
    this.reqTime = 0;
    this.preventStageNum = 0; // 上一次阶段打点标识

    this.checkWhiteScreenNum = 0; // 白屏檢查次數

    this.reportOnlyMap = {}; // 相同的错误不重复上报

    this.pagehash = 0; // 页面唯一id

    this.swTwoVersionPubObj = {}; // 守望二期公共数据

    this.pageObj = undefined;
    this.routerChange = false;
    this.problem = 0; // 现象类型值

    this.errorHappen = false; // 判断页面有没有发生异常

    this.initFc(vue);
  }
  /**
   * 初始化函数执行
   */


  _createClass(YjErrorReport, [{
    key: "initFc",
    value: function initFc(vue) {
      //  初始化守望二期上报基本数据
      this.initTwoVersionReportData();
      this.initPageObj(); //  监听路由改变

      this.listenerHistoryChange(); //  监听页面退出

      this.listenerPageHide(); // 守望二期数据延迟批量上报

      this.timerReportData();

      try {
        this.listenerWindowError();
        this.listenerVueError(vue);
        this.listenerResourceError();
        this.listenerUnhandledrejectionError();
        this.listenerAjaxError();
      } catch (err) {
        console.log(err);
        console.log('ie??? gun!!!');
      }
    }
  }, {
    key: "initPageHash",
    value: function initPageHash() {
      this.pagehash = Math.floor(Math.random() * 10000000);
    }
    /**
     * 监听页面退出事件 (ios wkwebview无法监听)
     */

  }, {
    key: "listenerPageHide",
    value: function listenerPageHide() {
      var _this = this;

      if (!this.pageObj) return;
      window.addEventListener('pagehide', function () {
        if (!_this.errorHappen && Array.isArray(_this.pageObj.stage) && _this.pageObj.stage.indexOf(_this.currentStage.substr(2)) < 0 && !_this.routerChange) {
          _this.writeErrorReportStorage({
            excTime: Date.now(),
            type: '-1',
            msg: JSON.stringify({
              stage: _this.currentStage
            }),
            errorKey: 'pagehide'
          });
        }
      }, false);
    }
    /**
     * 初始化守望二期上报通用参数
     */

  }, {
    key: "initTwoVersionReportData",
    value: function initTwoVersionReportData() {
      var _this2 = this;

      this.swTwoVersionPubObj = {
        oSPlatform: getAppClient(),
        wechatVerison: getWechatVerison(),
        oSversion: getOsVersion(),
        appVerison: getAppIdForH5(),
        deviceId: appUa.mobile_id || '',
        // 待完善
        network: '',
        // 待完善
        packageName: this.packageName,
        packageVersion: this.packageVersion,
        env: this.environment
      };
      getWebLoadTimeInfo(function (obj) {
        if (obj) {
          _this2.swTwoVersionPubObj.network = obj.netWork;
          _this2.webviewTime = obj.loadTime;
          _this2.reqTime = obj.reqTime;
        } else {
          _this2.swTwoVersionPubObj.network = getNetworkInfo().effectiveType || '';
        }
      });
    } //  监听路由改变

  }, {
    key: "listenerHistoryChange",
    value: function listenerHistoryChange() {
      var _history = history;
      var oldPushState = _history.pushState;
      var oldReplaceState = _history.replaceState;
      var self = this;

      _history.pushState = function (state, title) {
        var router = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        if (location.pathname !== router.split('?')[0]) {
          self.routerChange = true;
          self.routerChangeFc(router);
        }

        return oldPushState.apply(this, arguments);
      };

      _history.replaceState = function (state, title) {
        var router = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        if (location.pathname !== router.split('?')[0]) {
          self.routerChange = true;
          self.routerChangeFc(router);
        }

        return oldReplaceState.apply(this, arguments);
      };
    }
    /**
     * 初始化当前页面对象
     */

  }, {
    key: "initPageObj",
    value: function initPageObj(router) {
      var href = router || location.href;
      var pageArr = this.stageFlowPage.filter(function (key) {
        if (href.split('?')[0].indexOf(key.router) > -1) {
          return true;
        }

        return false;
      });
      this.pageObj = pageArr[0];
      this.stageObj = {};

      if (this.pageObj) {
        this.initPageHash();
        this.errorHappen = false;
        this.currentStageTime = {};
        this.currentStage = '0'; // eslint-disable-next-line no-undef

        this.currentStageTime['0'] = this.routerChange ? 0 : window.yj_g && window.yj_g.pagePrintTime || Date.now();
        this.preventStageNum = 0;
        this.swTwoVersionPubObj.pageId = this.pageObj.pageId;
        setlocalStorage('sw_log_pageobj', {
          hash: this.pagehash,
          data: this.getReportPubData()
        });
      }
    }
    /**
     * 路由改变执行函数
     */

  }, {
    key: "routerChangeFc",
    value: function routerChangeFc(router) {
      this.initPageObj(router);
      var pageObjDataBak = getlocalStorage('app_page_access_doc_bak') || {}; //  如果切换路由后，页面又要上报，并且上一个页面出现过错误数据，则把数据取出

      if (Object.keys(pageObjDataBak).length) {
        setlocalStorage('app_page_access_doc', pageObjDataBak);
      }
    }
    /**
     * 守望二期数据延迟批量上报方法
     */

  }, {
    key: "timerReportData",
    value: function timerReportData() {
      var _this3 = this;

      var resourceWhiteData = getlocalStorage('error_phenomenon_data') || [];
      if (resourceWhiteData.length) this.errorDataRecordStorage(resourceWhiteData);
      if (!this.stageFlowPage.length) return; //  取出暂存的页面打开数据

      var pageStageDataBak = getlocalStorage('app_page_access_doc_bak') || {};

      if (Object.keys(pageStageDataBak).length) {
        setlocalStorage('app_page_access_doc', pageStageDataBak);
        saveLocalStorage('app_page_access_doc_bak', '');
      } //  进入项目就读取localstorage里的数据


      var pageStageData = getlocalStorage('app_page_access_doc') || [];
      var errorData = getlocalStorage('app_error_record_doc') || [];
      var networkData = getlocalStorage('app_network_access_doc') || [];
      var pageObjData = getlocalStorage('sw_log_pageobj') || [];
      /**
       *  等下一次进入h5页面取本地storage判断数量是否达到上报标准
       */

      setTimeout(function () {
        var num = pageStageData.length + errorData.length + networkData.length + pageObjData.length;

        if (num > 100) {
          var arr = ['app_page_access_doc', 'app_error_record_doc', 'app_page_access_doc_bak', 'app_network_access_doc', 'sw_log_pageobj'];
          arr.forEach(function (key) {
            saveLocalStorage(key, '');
          });
        }

        if (num > 10) {
          var report = '';

          var pageStage = _this3.returnReportData(pageStageData, pageObjData, 'app_page_access_doc');

          var err = _this3.returnReportData(errorData, pageObjData, 'app_error_record_doc');

          var network = _this3.returnReportData(networkData, pageObjData, 'app_network_access_doc');

          report = pageStage + err + network;

          _this3.reportSwTwoDataAjax(report, {
            app_page_access_doc: pageStageData.length,
            app_error_record_doc: errorData.length,
            app_network_access_doc: networkData.length,
            sw_log_pageobj: pageObjData.length
          }, false);
        }
      }, 3000);
    }
    /**
     * 输出不同类型上报数据
     * @param {*} obj 
     * @param {*} pageObjData 
     * @param {*} indexName
     */

  }, {
    key: "returnReportData",
    value: function returnReportData(obj, pageObjData, indexName) {
      var newobj = deepClone(obj);
      var newarr = [];
      newobj.forEach(function (key) {
        var page = pageObjData.filter(function (p) {
          return key.hash === p.hash;
        });
        if (!page.length) return;
        Object.assign(key.data, page[0].data);
        newarr.push(key.data);
      });
      var str = '';
      newarr.forEach(function (item) {
        str += "{\"index\": {\"_index\" : \"".concat(indexName, "\"}}\n");
        str += "".concat(JSON.stringify(item), "\n");
      });
      return str;
    }
    /**
     * 守望二期数据接口上报方法
     * @param {*} report 
     * @param {*} oldObj
     * @param {*} only
     */

  }, {
    key: "reportSwTwoDataAjax",
    value: function reportSwTwoDataAjax(report, oldObj, only) {
      var _this4 = this;

      var xhr = new XMLHttpRequest();
      var url = this.environment === 'test' ? '//txst.yunjiglobal.com/sw_log/report_bulk/' : '//appsw.yunjiglobal.com/sw_log/report_bulk/';
      xhr.open('post', url);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200 && !only) {
          Object.keys(oldObj).forEach(function (key) {
            var val = getlocalStorage(key);
            if (!val) return;
            var data = _this4.pageObj ? getlocalStorage(key).slice(oldObj[key]) : '';
            saveLocalStorage(key, data);
          });
          var swLogObj = getlocalStorage('sw_log_pageobj') || []; //  数据上报后还有打点的情况，需要重新初始化sw_log_pageobj

          if (swLogObj.length === 0 && _this4.pagehash) {
            setlocalStorage('sw_log_pageobj', {
              hash: _this4.pagehash,
              data: _this4.getReportPubData()
            });
          }
        }
      };

      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', this.environment === 'test' ? 'Basic dGVzdGJ1bGs6dGVzdGJ1bGs' : 'Basic YXBwc3c6WXVuamlhcHBzd0AyMDIw');
      xhr.send(report);
    }
    /**
     * 白屏檢查
     */

  }, {
    key: "openCheckWhiteScreen",
    value: function () {
      var _openCheckWhiteScreen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(errorobj, errorKey, type) {
        var _this5 = this;

        var appCont, appContAr, appua;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.checkWhiteScreenNum > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.checkWhiteScreenNum += 1; //  睡眠一会儿再检测

                _context.next = 5;
                return sleep(1000);

              case 5:
                window.openCheckWhiteScreenCb = function (url) {
                  var msg = _objectSpread({
                    img_url: url
                  }, errorobj);

                  _this5.errorPhenomenon({
                    problem: 2,
                    msg: JSON.stringify(msg),
                    errorKey: errorKey,
                    type: type
                  });
                };

                appCont = getQueryString('appCont') || 0;
                appContAr = ['1', '2'];
                appua = appUa();

                if (appContAr.indexOf(appCont) > -1 && appua.appIdForH5 >= '20200212') {
                  try {
                    if (appua.appClient === 'ios' && appua.useWkWeb == 1) {
                      window.webkit.messageHandlers.openCheckWhiteScreen.postMessage({
                        funcName: 'openCheckWhiteScreenCb'
                      });
                    }

                    if (appua.appClient === 'ios' && appua.useWkWeb != 1) {
                      yjapp.openCheckWhiteScreen({
                        funcName: "openCheckWhiteScreenCb"
                      });
                    }

                    if (appua.appClient === 'android') {
                      yjapp.openCheckWhiteScreen('{"funcName": "openCheckWhiteScreenCb"}');
                    }
                  } catch (err) {}
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openCheckWhiteScreen(_x, _x2, _x3) {
        return _openCheckWhiteScreen.apply(this, arguments);
      }

      return openCheckWhiteScreen;
    }()
    /**
     * 网络诊断方法
     * @param {*} hostname 
     */

  }, {
    key: "networkDiagnosis",
    value: function networkDiagnosis(hostname) {
      var _this6 = this;

      if (hostname.indexOf('/') > -1) return;
      var el = new Image();
      el.src = "//".concat(hostname);

      var fn = function fn(type) {
        _this6.writeErrorReportStorage({
          excTime: Date.now(),
          type: '-1',
          problem: 8,
          msg: JSON.stringify({
            stage: _this6.currentStage,
            errorType: type
          }),
          errorKey: "ping ".concat(hostname, " error")
        });
      };

      el.onerror = function () {
        fn('onerror');
      };

      el.onabort = function () {
        fn('onabort');
      };
    }
    /**
     * 异常现象上报 (批量延遲)
     * @param {*} arr 
     */

  }, {
    key: "errorDataRecordStorage",
    value: function errorDataRecordStorage(arr) {
      var _this7 = this;

      var str = '';
      arr.forEach(function (key) {
        var obj = _this7.getReportPubData();

        Object.assign(obj, {
          excTime: key.excTime,
          type: '104',
          msg: JSON.stringify(key.msg),
          errorKey: key.errorKey || '',
          problem: key.problem
        });
        var url = key.page.replace(/(http|https):\/\//, '');
        url = url.split('?')[0];

        var pageArr = _this7.stageFlowPage.filter(function (key) {
          if (url.indexOf(key.router) > -1) {
            return true;
          }

          return false;
        });

        var pageObj = pageArr[0]; // 如果當前頁面有pageId映射

        if (pageObj) obj.pageId = pageObj.pageId;
        if (!pageObj) obj.pageId = url;
        str += '{"index": {"_index" : "app_error_record_doc"}}\n';
        str += "".concat(JSON.stringify(obj), "\n");
      });
      this.reportSwTwoDataAjax(str, {}, true);
      saveLocalStorage('error_phenomenon_data', '');
    }
    /**
     * 异常现象上报 (單條即時)
     */

  }, {
    key: "errorPhenomenon",
    value: function errorPhenomenon(newObj) {
      var obj = this.getReportPubData();
      Object.assign(obj, {
        excTime: Date.now(),
        type: '-1',
        errorKey: ''
      });
      Object.assign(obj, newObj);

      if (!obj.pageId) {
        var url = location.href.replace(/(http|https):\/\//, '');
        url = url.split('?')[0];
        obj.pageId = url;
      }

      var str = '';
      str += '{"index": {"_index" : "app_error_record_doc"}}\n';
      str += "".concat(JSON.stringify(obj), "\n");
      this.reportSwTwoDataAjax(str, {}, true);
    }
  }, {
    key: "logDebug",
    value: function logDebug() {
      var _console$log;

      var time = format(Date.now(), 'yyyy-MM-dd hh:mm:ss');
      var timeLog = [{
        timeLog: time
      }];
      var args = [].concat(timeLog, Array.prototype.slice.call(arguments));

      (_console$log = console.log).call.apply(_console$log, [this].concat(_toConsumableArray(args))); // 上传app


      monitorLog('h5_log_debug', args);
    }
    /**
     * 打点记录
     */

  }, {
    key: "recordStage",
    value: function recordStage(stageNum) {
      var _this8 = this;

      if (typeof window === 'undefined') return;
      if (this.routerChange) return;
      var num = parseInt(stageNum, 0); //  如果当前点已经记录过

      if (this.currentStageTime[num]) return;
      if (!this.pageObj) return;

      if (this.currentStage.indexOf('0') > -1) {
        this.currentStage = "".concat(this.currentStage, "-").concat(num);
        this.currentStageTime[num] = Date.now();
        var numPre = this.currentStageTime[this.preventStageNum];
        this.preventStageNum = num; //  如果第一个点没有值

        this.stageObj["step".concat(num)] = numPre === 0 ? 0 : this.currentStageTime[num] - numPre;
        var webviewTime = this.webviewTime !== 0 ? this.webviewTime - this.reqTime : 0;
        if ("".concat(webviewTime).length > 5) webviewTime = 0;
        var reportData = {
          // eslint-disable-next-line no-undef
          reqTime: this.routerChange ? Date.now() : this.reqTime || Date.now(),
          // eslint-disable-next-line no-undef
          webviewTime: this.routerChange ? 0 : webviewTime,
          step: this.stageObj
        }; //  如果上报的阶段超过了初始化时设置的阶段，则直接拦截不记录

        var currentIsMax = this.pageObj.stage.filter(function (key) {
          if (_this8.currentStage.substr(2).indexOf(key) > -1 && _this8.currentStage.substr(2).length > key.length) {
            return true;
          }

          return false;
        });
        if (currentIsMax.length) return;
        saveLocalStorage('app_page_access_doc_bak', {
          hash: this.pagehash,
          data: reportData
        });

        if (this.pageObj.stage.indexOf(this.currentStage.substr(2)) > -1) {
          setlocalStorage('app_page_access_doc', {
            hash: this.pagehash,
            data: reportData
          });
          saveLocalStorage('app_page_access_doc_bak', '');
          setlocalStorage('app_error_record_doc', {
            hash: this.pagehash,
            data: {
              excTime: Date.now(),
              type: 0,
              msg: '',
              errorKey: ''
            }
          });
        }
      }
    }
    /**
     * 获取守望二期上报通用参数
     */

  }, {
    key: "getReportPubData",
    value: function getReportPubData() {
      return Object.assign(this.swTwoVersionPubObj, {
        shopId: getQueryString('shopId') || '',
        userId: this.errorReportUser
      });
    }
    /**
    * 全局js运行时error上报
    */

  }, {
    key: "listenerWindowError",
    value: function listenerWindowError() {
      var _this9 = this;

      window.onerror = function (message, source, lineno, colno, error) {
        try {
          if (message.indexOf('Script error') > -1) return;
          if (!error) return;
          if (error && typeof error.stack !== 'string') return;
          var errorKey = message || error.stack.split('\n')[0];
          var stackStr = error.stack;
          if (stackStr === '') return; // 堆栈内容为空过滤

          if (stackStr.indexOf(':1:1') > -1) return;
          if (errorKey === '') return;
          if (errorKey == "Network Error") return; // axios 发起的多余错误过滤

          if (_this9.pageObj) {
            _this9.errorHappen = true;

            _this9.writeErrorReportStorage({
              excTime: Date.now(),
              type: codeMap.jsError,
              msg: JSON.stringify({
                stage: _this9.currentStage
              }),
              errorKey: errorKey
            });
          }

          _this9.openCheckWhiteScreen({
            current_url: location.href
          }, errorKey, 102);

          _this9.errObjReport(error.stack, errorKey, 'jsError');
        } catch (err) {
          console.info(message);
        }
      };
    }
    /**
     * 全局Vue运行时error上报
     */

  }, {
    key: "listenerVueError",
    value: function listenerVueError(vue) {
      if (typeof vue === 'undefined') return;
      var self = this;
      var oldVueError = vue.config.errorHandler;

      var isFunction = function isFunction(obj) {
        return Object.prototype.toString.call(obj) === '[object Function]';
      };

      vue.config.errorHandler = function errorHandler(err, vm, info) {
        console.error('handleVueError ->', err);
        var message = "".concat(err.stack, " \nerrorInfo: ").concat(info);
        var errorKey = err.toString();

        if (errorKey) {
          errorKey = errorKey.replace(/(http|https):/, '');
          errorKey = errorKey.replace(/\?[\w\d&=]*:/, ':');
        }

        if (self.pageObj) {
          self.errorHappen = true;
          self.writeErrorReportStorage({
            excTime: Date.now(),
            type: codeMap.vueError,
            msg: JSON.stringify({
              stage: self.currentStage
            }),
            errorKey: errorKey
          });
        }

        self.openCheckWhiteScreen({
          current_url: location.href
        }, errorKey, 101);
        self.errObjReport(message, errorKey, 'vueError');

        if (oldVueError && isFunction(oldVueError)) {
          oldVueError.call(this, err, vm, info);
        }
      };
    }
    /**
     * 全局资源加载失败error上报
     */

  }, {
    key: "listenerResourceError",
    value: function listenerResourceError() {
      var _this10 = this;

      //  移除
      if (typeof yj_fc === 'undefined' || typeof yj_fc.resourceErrorListenerFc === 'undefined') return; //  当前页面没有发生资源加载错误

      if (yj_var && !yj_var.resourceErrorDot) {
        var resourceErrorList = JSON.parse(localStorage.getItem('resourceErrorList') || '[]');
        resourceErrorList.forEach(function (key) {
          // 如果本地存储中有资源加载失败，并且和当前链接匹配
          if (key.pathname === location.pathname) {
            var errorKey = "resource error: ";
            key.data.forEach(function (item) {
              errorKey += "".concat(item.name, "->").concat(item.url);
            }); //  记录这一次资源加载失败

            _this10.writeErrorReportStorage({
              excTime: key.date,
              type: codeMap.resourceError,
              msg: '',
              errorKey: errorKey
            }); //  记录这一次页面打开


            setlocalStorage('app_page_access_doc', {
              hash: _this10.pagehash,
              data: {
                reqTime: key.date,
                webviewTime: 0,
                step: {}
              }
            });
          }
        });
      }
    }
    /**
     * 监听Promise未处理的错误
     */

  }, {
    key: "listenerUnhandledrejectionError",
    value: function listenerUnhandledrejectionError() {
      var _this11 = this;

      window.addEventListener("unhandledrejection", function (event) {
        try {
          if (event.reason && typeof event.reason.stack !== 'string') return;
          var stackStr = event.reason.stack;
          var errorKey = event.reason.message || stackStr.split('\n')[0];
          if (stackStr.indexOf(':1:1') > -1) return;
          if (errorKey === '') return;
          if (errorKey == "Network Error") return; // 过滤 axios 发起的多余错误

          if (_this11.pageObj) {
            _this11.errorHappen = true;

            _this11.writeErrorReportStorage({
              excTime: Date.now(),
              type: codeMap.jsError,
              msg: JSON.stringify({
                stage: _this11.currentStage
              }),
              errorKey: errorKey
            });
          }

          _this11.openCheckWhiteScreen({
            current_url: location.href
          }, errorKey, 102);

          _this11.errObjReport(stackStr, errorKey, 'jsError');
        } catch (err) {
          console.error(err);
        }
      });
    }
    /**
     * 写入异常数据
     */

  }, {
    key: "writeErrorReportStorage",
    value: function writeErrorReportStorage(data) {
      var newData = deepClone(data);
      if (this.problem !== 0) newData.problem = this.problem; // monitorLog('h5_abnormal_log',{
      //   hash: this.pagehash,
      //   data: newData
      // }) 

      setlocalStorage('app_error_record_doc', {
        hash: this.pagehash,
        data: newData
      });
    } // 整合接口上报数据

  }, {
    key: "getPortData",
    value: function getPortData(res, objNew) {
      var errObj = {
        projectName: this.projectName,
        //  项目名
        environment: this.environment,
        //  环境
        user: this.errorReportUser,
        //  用户信息
        consumerId: this.consumerId,
        // 用户consumerId
        os: getOsVersion(),
        //  用户操作系统 
        appClient: getAppClient(),
        //  用户操作平台
        appIdForH5: getAppIdForH5(),
        //  云集APP版本信息
        ua: navigator.userAgent,
        //  浏览器ua信息
        eventTime: new Date().toISOString(),
        //  bug上报时间
        shopId: getQueryString('shopId') || '',
        // eslint-disable-next-line no-restricted-globals
        hrefurl: location.href,
        //  当前访问链接
        packageName: this.packageName,
        //  所属项目包名
        packageVersion: this.packageVersion,
        //  所属项目包版本
        // errorMessage: message, //  错误详情
        // errorKey: key, //  错误信息关键字
        // errorType: errorType, //  错误信息类型
        errorTree: '',
        //  错误流程树
        responseHeader: res.responseHeader,
        responseBody: res.responseBody,
        requestHeader: res.requestHeader,
        requestBody: res.requestBody,
        cookie: document.cookie
      };
      var ajaxdata = Object.assign(objNew, errObj);
      return ajaxdata;
    }
  }, {
    key: "getCodeZero",
    value: function getCodeZero(res, obj) {
      var sign = '';
      var responseBody = JSON.parse(res.responseBody);

      if (responseBody.code || responseBody.errorCode) {
        if (responseBody.code === 0 || responseBody.errorCode === 0) {
          sign = 'h5_network_log';
        } else {
          sign = 'h5_network_notzero';
        }
      } else {
        sign = 'h5_network_log';
      } // console.log(sign, this.getPortData(res, obj))


      monitorLog(sign, this.getPortData(obj.res, obj));
    }
    /**
     * 处理ajax上报数据
     */

  }, {
    key: "machiningAjaxRepData",
    value: function machiningAjaxRepData(obj, type) {
      // 如果请求成功
      if (this.apiReportSwitch) {
        setlocalStorage('app_network_access_doc', {
          hash: this.pagehash,
          data: obj
        });
      }

      if (type === 'load' && obj.code === 200 && this.ajaxCodefilter.indexOf(status) === -1) {
        this.getCodeZero(obj.res, obj);
      }

      try {
        if (type !== 'load' && !(obj.code >= 200 && obj.code < 300) && this.ajaxCodefilter.indexOf(status) === -1) {
          var newobj = deepClone(obj);
          var data = Object.assign(newobj, {
            type: type,
            stage: this.currentStage
          });
          this.errorHappen = true;
          monitorLog('h5_network_error', this.getPortData(obj.res, obj));
          this.writeErrorReportStorage({
            excTime: Date.now(),
            type: codeMap.ajaxError,
            msg: JSON.stringify(data),
            errorKey: "ajaxError: ".concat(obj.url, " ").concat(obj.code)
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
    /**
     * 接口请求上报
     * @param {*} event 
     */

  }, {
    key: "handleEvent",
    value: function handleEvent(event, res) {
      if (!event.target) return;
      var type = event.type;
      var _event$target = event.target,
          status = _event$target.status,
          statusText = _event$target.statusText,
          response = _event$target.response,
          readyState = _event$target.readyState,
          timeout = _event$target.timeout,
          reqTime = _event$target.reqTime,
          reqType = _event$target.reqType,
          traceId = _event$target.traceId;
      var url = event.target.responseURL || event.target.reqUrl;
      var spendTime = Math.abs(Date.now() - reqTime);
      res.responseBody = JSON.parse(JSON.stringify(response));
      res.requestHeader = event.target.getAllResponseHeaders();
      if (url.indexOf('jserror_log/report') > -1) return;
      if (url.indexOf('sw_log/report_bulk') > -1) return;
      if (url.indexOf('sync_js') > -1) return;

      var _url$split = url.split('//'),
          _url$split2 = _slicedToArray(_url$split, 2),
          protocols = _url$split2[0],
          urls = _url$split2[1];

      var _urls$split = urls.split('?'),
          _urls$split2 = _slicedToArray(_urls$split, 1),
          ur = _urls$split2[0];

      var protocol = protocols ? protocols.split(':')[0] : location.protocol.split(':')[0];
      var reqUrl = ur;
      var withName = ['.jpg', '.png', '.gif', '.webp']; // 如果当前页面需要守望系统二期的统计功能

      if (this.pageObj) {
        try {
          if (!reqUrl || typeof reqUrl.indexOf === 'undefined') return; // 接口数量上报灰度控制

          if (withName.filter(function (key) {
            return reqUrl.indexOf(key) > -1;
          }).length === 0) {
            this.machiningAjaxRepData({
              url: reqUrl,
              protocol: protocol,
              reqType: reqType,
              code: status,
              reqTime: reqTime,
              spendTime: spendTime,
              traceId: traceId || '',
              network: getNetworkMsg(),
              res: res
            }, type);
          }
        } catch (err) {
          console.log('');
        }
      } else {
        try {
          // 接口数量上报灰度控制
          if (withName.filter(function (key) {
            return reqUrl.indexOf(key) > -1;
          }).length === 0) {
            this.machiningAjaxRepData({
              url: reqUrl,
              protocol: protocol,
              reqType: reqType,
              code: status,
              reqTime: reqTime,
              spendTime: spendTime,
              traceId: traceId || '',
              network: getNetworkMsg(),
              res: res
            }, type);
          }
        } catch (err) {
          console.log('');
        }
      }

      try {
        if (this.ajaxCodefilter.indexOf(status) === -1 && !(status >= 200 && status < 300)) {
          url = url.replace(/(http|https):\/\//, '');
          if (!url) return;
          var msg = "status  \u2014\u2014>  ".concat(status, " \n") + "statusText  \u2014\u2014> ".concat(statusText, "  \n") + "readyState  \u2014\u2014> ".concat(readyState, " \n") + "timeout  \u2014\u2014> ".concat(timeout, " \n") + "type  \u2014\u2014> ".concat(type, " \n") + "url  \u2014\u2014> ".concat(url, " \n") + "spendTime  \u2014\u2014> ".concat(spendTime, "ms \n") + "response  \u2014\u2014> ".concat(response, " \n") + "network  \u2014\u2014> ".concat(getNetworkMsg());
          var key = "ajaxError: ".concat(url.split('?')[0], " ").concat(status);
          this.openCheckWhiteScreen({
            current_url: location.href
          }, key, 103);
          this.errObjReport(msg, key, 'ajaxError');
        }
      } catch (err) {
        console.error(err);
      }
    } // getHeaders(){
    //   var req = new XMLHttpRequest();
    //   req.open('GET', document.location.href, false);
    //   req.send(null);
    //   var headerArr = req.getAllResponseHeaders().split('\n');
    //   var headers = {};
    //   headerArr.forEach(item=>{
    //       if(item!==''){
    // 	    var index = item.indexOf(':');
    //         var key = item.slice(0,index);
    //         var value = item.slice(index+1).trim();
    //         headers[key] = value
    //     }
    //   })
    //   console.log(headers)
    //   debugger
    //   return headers
    // }

    /**
     * 全局ajax方法错误error上报
     */

  }, {
    key: "listenerAjaxError",
    value: function listenerAjaxError() {
      var protocol = window.location.protocol;
      var self = this;
      if (protocol === 'file:') return; // 处理XMLHttpRequest

      if (!window.XMLHttpRequest) return; // 请求发起时间

      function loadstartFc() {
        this.reqTime = Date.now();
      }

      var xmlhttp = window.XMLHttpRequest;
      var oldOpen = xmlhttp.prototype.open;
      var oldSend = xmlhttp.prototype.send;
      var oldSetRequestHeader = xmlhttp.prototype.setRequestHeader;
      /**
       * 重写ajax请求设置header方法，用于守望二期的traceId上报
       */

      xmlhttp.prototype.setRequestHeader = function setRequestHeader() {
        try {
          if (arguments && arguments[0] === 'YJ-traceId' && arguments[1]) {
            this.traceId = arguments[1];
          }
        } catch (err) {
          console.error('XMLHttpRequest Rewrite setRequestHeader Fc error:', err);
        }

        return oldSetRequestHeader.apply(this, arguments);
      };

      xmlhttp.prototype.open = function open() {
        this.reqUrl = arguments[1] || '';
        this.reqType = arguments[0] || '';
        return oldOpen.apply(this, arguments);
      };

      xmlhttp.prototype.send = function send() {
        if (this.addEventListener) {
          var res = {
            requestBody: arguments[0],
            requestHeader: null,
            responseBody: null,
            responseHeader: null
          };
          this.addEventListener('loadstart', loadstartFc);
          this.addEventListener('load', function (event) {
            return self.handleEvent(event, res);
          });
          this.addEventListener('abort', function (event) {
            return self.handleEvent(event, res);
          });
          this.addEventListener('error', function (event) {
            return self.handleEvent(event, res);
          });
          this.addEventListener('timeout', function (event) {
            return self.handleEvent(event, res);
          });
        }

        return oldSend.apply(this, arguments);
      };
    }
    /**
     * 数据上报Post
     * @param {*} json 
     */

  }, {
    key: "reportAjax",
    value: function reportAjax(json) {
      if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
        console.error('错误监控数据上报:', json);
        return;
      } // 防止一个页面出现同样的错误多次上报


      if (this.reportOnlyMap[json.errorKey]) {
        return;
      } else {
        this.reportOnlyMap[json.errorKey] = true;
      }

      var errorList = {
        'ajaxError': 'h5_network_error',
        'jsError': 'h5_error_js',
        'vueError': 'h5_error_vue'
      };
      monitorLog(errorList[json.errorType], json);
      var xhr = new XMLHttpRequest();
      xhr.open('post', '//current.yunjiglobal.com/jserror_log/report/');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', 'Basic bG9ndmlldzpsb2d2aWV3');
      xhr.send(JSON.stringify(json));
    }
    /**
     * 上报执行函数
     */

  }, {
    key: "errObjReport",
    value: function errObjReport(message, key, errorType) {
      var errObj = {
        projectName: this.projectName,
        //  项目名
        environment: this.environment,
        //  环境
        user: this.errorReportUser,
        //  用户信息
        consumerId: this.consumerId,
        // 用户consumerId
        os: getOsVersion(),
        //  用户操作系统 
        appClient: getAppClient(),
        //  用户操作平台
        appIdForH5: getAppIdForH5(),
        //  云集APP版本信息
        ua: navigator.userAgent,
        //  浏览器ua信息
        eventTime: new Date().toISOString(),
        //  bug上报时间
        // eslint-disable-next-line no-restricted-globals
        url: location.href,
        //  当前访问链接
        packageName: this.packageName,
        //  所属项目包名
        packageVersion: this.packageVersion,
        //  所属项目包版本
        errorMessage: message,
        //  错误详情
        errorKey: key,
        //  错误信息关键字
        errorType: errorType,
        //  错误信息类型
        errorTree: '' //  错误流程树

      };
      this.reportAjax(errObj);
    }
    /**
     * 设置用户信息
     */

  }, {
    key: "setUserId",
    value: function setUserId(str) {
      this.errorReportUser = str;
    }
    /**
     * 设置错误现象类型
     * @param {*} problem 
     */

  }, {
    key: "setProblem",
    value: function setProblem(problem) {
      this.problem = problem;
    }
  }]);

  return YjErrorReport;
}();

module.exports = YjErrorReport;